import React from 'react';
import { noop } from 'lodash';

export const AdminPlacePickerContext = React.createContext({
  open: noop,
  close: noop,
});
